import { makeEnvironmentProviders, Type } from '@angular/core';
import { Route, ROUTES } from '@angular/router';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';
import { UnauthorizedPageComponent } from './containers/unauthorized-page.component';
import { MainMenuItemService } from './ui-services';

export interface ShellModuleConfig {
  mainMenuItemService: Type<MainMenuItemService>;
}

const additionalRootRoutes: Route[] = [
  {
    path: 'unauthorized',
    component: UnauthorizedPageComponent
  }
];

export function provideShell(config: ShellModuleConfig) {
  return makeEnvironmentProviders([
    { provide: MainMenuItemService, useClass: config.mainMenuItemService },
    { provide: ROUTES, useValue: additionalRootRoutes, multi: true },
    { provide: ICON_SETTINGS, useValue: { type: 'font' } }
  ]);
}
